import styled from 'styled-components';

export const StyledObjectInfo = styled.div`
    height: 0%;
    width: 0%;
`;